<template>
  <div class="screen-score" :class="{'filter-blur':activitymoadal==true}">
    <div class="student-list-wra" v-if="evaluate && evaluate.length>0" v-scrollBar>
      <ul class="student-list" ref="studentList">
        <li
          class="student-item clearfix"
          v-for="(item,index) in evaluate"
          :key="'score-object' + index"
        >
          <div class="info clearfix">
            <img
              class="student-headImg"
              :src="getImg(item.headImage)"
              alt="student"
              v-if="scoreModel.type == 1"
            />
            <span class="name ellipsis-one" :title="item.name">{{item.name}}</span>
          </div>
          <div class="score-info">
            <!-- <span class="scored-num" @click="goDetail(item.selectId)">({{item.markCount}}{{ $t("grade.gradeNum") }})</span> -->
            <span class="scored-num" @click="goDetail(item.selectId)">({{ $t("grade.gradeNum",{num:item.markCount}) }})</span>
            <span class="score">{{ $t("grade.points", { n: item.score > 0 || item.score === 0 ? item.score : '--' }) }}</span>
          </div>
          <span class="iconfont icon-fail-" @click="endTheMark(item.selectId)"></span>
          <div class="score-progress" :style="{'width': item.score >= 0 ? item.score +'%' : 0}"></div>
        </li>
      </ul>
    </div>
    <p class="no-student-tip" v-else-if="!isLoading">{{ $t("system.tip6") }}</p>
    <p class="haveEnd" @click="goEndList">{{ $t("system.tip7") }}({{endevaluate.length}})</p>
  </div>
</template>

<script>
export default {
  name: "score",
  props: { activitymoadal: Boolean },
  data() {
    return {
      userId: 0,
      scoreId: 0,
      scoreModel: {},
      endevaluate: [],
      evaluate: [],
      modal: false,
      isLoading: false
    };
  },
  methods: {
    //轮训查询投票详情
    getDetail() {
      var self = this;
      this.timer = setInterval(function() {
        self.getScoreDetail();
      }, 2000);
    },
    getScoreDetail() {
      var self = this;
      self.$http
        .get(
          `${self.baseURL1}/classscore/getDetail?userId=${self.userId}&id=${self.scoreId}&roleId=9`
        )
        .then(res => {
          self.scoreModel = res.data;
          self.endevaluate = res.data.endevaluate || [];
          self.evaluate = res.data.evaluate || [];
          self.$emit("pushDetial", res.data);
          self.isLoading = false;
          if (self.scoreModel.status == 1) {
            self.goEndList();
          }
        });
    },
    addStudent() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    goDetail(id) {
      this.$router.replace(`/screenIndex/scoreDetail/${id}`);
    },
    getImg(imgUrl) {
      return this.common.handleImg(imgUrl, this.rescourceURL);
    },
    goEndList() {
      this.$router.replace("/screenIndex/scoreEndList");
    },
    endTheMark(id) {
      const self = this;
      self.$http
        .post(
          `${this.baseURL1}/classscore/updateEvaluationForPersonal?selectId=${id}&status=1`
        )
        .then(res => {
          self.getScoreDetail();
        });
    }
  },
  created: function() {
    this.userId = this.common.getCookie("userId");
    this.scoreId = this.common.getCookie("activityId");
    this.isLoading = true;
    this.getScoreDetail();
    this.getDetail();
  },
  computed: {},
  watch: {},
  mounted: function() {},
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "score.scss";
</style>



// WEBPACK FOOTER //
// src/components/score/score.vue